<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>职业信息管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/work-info-company/table' }">职业信息公司</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="公司名称"
                          prop="name">
              <el-input v-model="form.name"
                        placeholder="请输入公司名称"
                        clearable>
              </el-input>
              <el-alert v-if="id"
                        type="info"
                        :closable="false"
                        show-icon
                        style="margin-top: 8px;">
                <template slot="default">
                  修改公司名称后只对新提交的职业信息审批生效，已提交的职业信息中的公司名称不会受影响。
                </template>
              </el-alert>
            </el-form-item>
          </div>
        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-check"
                     native-type="submit">保存
          </el-button>
          <el-button icon="el-icon-back"
                     @click="$router.push({name: '职业信息公司'})">取消
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        name: '',
      },
      formRules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { max: 200, message: '公司名称长度不能超过200个字符', trigger: 'blur' },
        ],
      },
    }
  },

  computed: {
    id () {
      return this.$route.params.id
    },
  },

  created () {
    if (this.id) {
      this.loadData()
    }
  },

  methods: {
    loadData () {
      request.page('workInfoCompanyGet', this.id).then(({data}) => {
        this.form = {
          name: data.name || '',
        }
      })
    },

    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }

        const api = this.id ? 'workInfoCompanyEdit' : 'workInfoCompanyCreate'
        const params = this.id ? {id: this.id, ...this.form} : this.form

        request.common(api, params).then(({data}) => {
          this.$message({
            showClose: true,
            message: this.id ? '修改成功' : '添加成功',
            type: 'success',
          })
          this.$router.push({name: '职业信息公司'})
        })
      })
    },
  },
}
</script>





// WEBPACK FOOTER //
// src/views/work-info-company/pages/WorkInfoCompanyForm.vue